import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Linkedin } from 'lucide-react';
import { navigation } from './navigation';

export default function Footer() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* CFSC Overview */}
        <div className="col-span-1">
          <h3 className="text-lg font-bold text-white mb-4">Climate Finance and Sustainability Centre</h3>
          <p className="text-sm text-gray-400">
            Advancing climate finance and sustainability training in Africa through education, research, and partnerships.
          </p>
        </div>

        {/* Location */}
        <div className="col-span-1">
          <h3 className="text-xs font-semibold text-gray-400 uppercase mb-4">Our Location</h3>
          <div className="space-y-3">
            <a 
              href="https://maps.app.goo.gl/htcW57MuEtDUJw9C9"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start space-x-3 text-sm hover:text-white transition-colors"
            >
              <MapPin className="h-5 w-5 flex-shrink-0 mt-1" />
              <span>
                Climate Finance and Sustainability Centre,<br />
                MUBS Main Building, 2nd Floor,<br />
                Plot 21 A, Port Bell Rd,<br />
                P.O Box 1337,<br />
                Kampala, Uganda
              </span>
            </a>
            <a 
              href="tel:+256757710981"
              className="flex items-center space-x-3 text-sm hover:text-white transition-colors"
            >
              <Phone className="h-5 w-5" />
              <span>+256 757 710981</span>
            </a>
            <a 
              href="mailto:climatefinance-sustainabilitycentre@mubs.ac.ug"
              className="flex items-center space-x-3 text-sm hover:text-white transition-colors"
            >
              <Mail className="h-5 w-5" />
              <span>climatefinance-sustainabilitycentre@mubs.ac.ug</span>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="col-span-1">
          <h3 className="text-xs font-semibold text-gray-400 uppercase mb-4">Quick Links</h3>
          <ul className="space-y-2">
            {navigation.main.filter(item => item.name !== 'Get Involved').map((item) => (
              <li key={item.name}>
                <Link 
                  to={item.href}
                  onClick={handleScrollToTop}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Resources & Social */}
        <div className="col-span-1">
          <div className="mb-6">
            <h3 className="text-xs font-semibold text-gray-400 uppercase mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/news#top"
                  onClick={handleScrollToTop}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link 
                  to="/events#top"
                  onClick={handleScrollToTop}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Events
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase mb-4">Connect with us</h3>
            <div className="flex space-x-4">
              <a 
                href="https://x.com/CFSC_UG"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg 
                  viewBox="0 0 24 24" 
                  className="h-5 w-5 fill-current"
                  aria-hidden="true"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
                <span className="sr-only">X (formerly Twitter)</span>
              </a>
              <a 
                href="https://www.linkedin.com/company/mubs-sustainability-and-climate-finance-centre/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Linkedin className="h-5 w-5" />
                <span className="sr-only">LinkedIn</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-700 py-4 text-center">
        <p className="text-xs text-gray-500">
          &copy; {new Date().getFullYear()} Climate Finance and Sustainability Centre. All rights reserved.
        </p>
      </div>
    </footer>
  );
}